import EditingUsedAssemblyMaterial from './EditingUsedAssemblyMaterial';

export default EditingUsedAssemblyMaterial;